import { useCallback, useMemo, useState } from 'react'
import classNames from 'classnames'
import { useLocation } from 'react-router-dom'
import { ChartSection } from '../chart-section/ChartSection'
import './PrescriptionsSection.scss'
import prescriptionIcon from '../../../../images/charts/Prescription.png'
import { NO_PRESCRIPTIONS_TEXT, VIDEO_CALL_NOTES_PRESCRIPTIONS_TITLE_TEXT } from '../../../../utils/constants'
import { useGetPatientsPatientIdPrescriptions } from '../../../../api/generated/prescription/prescription'
import { mapPrescriptionToLegacy } from '../../../../utils/prescriptionMapper'
import { Order, PageLoadingSpinner } from 'ui_kit_qmd'

type Props = {
  userTimeZone: string
  onSetPrescription: (prescription: ReturnType<typeof mapPrescriptionToLegacy>) => void
}

export const PrescriptionsSection = ({ userTimeZone, onSetPrescription }: Props) => {
  const [isCollapsed, setIsCollapsed] = useState(true)
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const id = params.get('id') ?? ''

  const { data: rawPrescriptions = [], isLoading } = useGetPatientsPatientIdPrescriptions(id, {
    query: { enabled: !isCollapsed && !!id },
  })

  const prescriptions = useMemo(() => rawPrescriptions.map(mapPrescriptionToLegacy), [rawPrescriptions])

  const toggleCollapsed = useCallback(() => {
    setIsCollapsed((prev) => !prev)
  }, [])

  return (
    // @ts-expect-error ChartSection is untyped JSX — accepts children via destructuring
    <ChartSection
      className={classNames('prescriptions-section-main-wrapper', {
        expanded: prescriptions.length && !isCollapsed,
        emptyContent: !prescriptions.length && !isCollapsed,
      })}
      title={VIDEO_CALL_NOTES_PRESCRIPTIONS_TITLE_TEXT}
      icon={prescriptionIcon}
      iconAltText='prescriptions'
      setIsCollapsed={toggleCollapsed}
      isCollapsed={isCollapsed}
      emptyText={!isLoading && NO_PRESCRIPTIONS_TEXT}
      userTimeZone={userTimeZone}
      isWithoutLastUpdated>
      {isLoading ?
        <PageLoadingSpinner />
      : prescriptions.length ?
        prescriptions.map((item) => (
          <Order
            key={item.PrescriptionId}
            onEdit={() => {}}
            onDelete={() => {}}
            onOpenOrder={() => {
              onSetPrescription({ ...item })
            }}
            order={{ ...item }}
          />
        ))
      : null}
    </ChartSection>
  )
}
